module.exports = __webpack_public_path__ + "media/St 4-thermostat-hint.babb17d9.wav";